import { Injectable, Inject, ViewChild } from '@angular/core';
declare var $: any;
declare var bootbox: any;

@Injectable()
export class JqueryDialogService {

    static isDialogVisible = false;
    isLoaderHiddenByMethod = false;
    loaderBootbox: any;
    showLoaderForPolling = false;
    constructor() {

    }

    // openJqueryDialog(htmlText: string, buttons: string[], parameters: any[], callback: (any) => void) {
    //     if (JqueryDialogService.isDialogVisible)
    //         return;
    //     JqueryDialogService.isDialogVisible = true;

    //     let objBtn = {};
    //     buttons.forEach((btn, i) => {
    //         objBtn[btn] = () => {
    //             JqueryDialogService.isDialogVisible = false;
    //             $("#custom-content-dialog-box").dialog("close");
    //             callback(parameters[i]);
    //         }
    //     });
    //     $('#custom-content-dialog-box-text').html(htmlText);
    //     $("#custom-content-dialog-box").dialog(
    //         {
    //             closeOnEscape: false,
    //             dialogClass: "no-close",
    //             buttons: objBtn
    //         }
    //     ).draggable({ containment: "none", scroll: false, revert: true, revertDuration: 0 });

    // }

    confirmDialogForUnsavedChanges(methodDelegate: (returnValue) => void = null) {
        if (JqueryDialogService.isDialogVisible) {
            return;
        }
        let htmlText = 'Do you want to save your changes?';
        JqueryDialogService.isDialogVisible = true;
        // tslint:disable-next-line:max-line-length
        htmlText = '<div class="bootbox-widget-header" style="padding-left: 6px;">Confirm</div><div class="bootbox-content" style="font-size:11px;font-weight:bold;text-align:center;padding-top:35px;">'
            + htmlText
            + '</div>';
        const noButtonLevel = 'No';
        const yesButtonLevel = 'Yes';

        const buttons = {
            cancel: {
                label: noButtonLevel,
                className: 'CommandButton cancel'
            },
            noclose: {
                label: 'I\'m a custom button, but I don\'t close the modal!',
                className: 'CommandButton',
            },
            ok: {
                label: yesButtonLevel,
                className: 'CommandButton confirm'
            }
        };

        bootbox.dialog({
            title: '',
            message: htmlText,
            size: 'small',
            buttons: {
                ok: {
                    label: yesButtonLevel,
                    className: 'CommandButton',
                    callback: () => {
                        JqueryDialogService.isDialogVisible = false;
                        methodDelegate(2);
                    }
                },
                cancel: {
                    label: noButtonLevel,
                    className: 'CommandButton',
                    callback: () => {
                        JqueryDialogService.isDialogVisible = false;
                        methodDelegate(1);
                    }
                },
                noclose: {
                    label: 'Cancel',
                    className: 'CommandButton',
                    callback: () => {
                        JqueryDialogService.isDialogVisible = false;
                        methodDelegate(0);
                    }
                }
            }
            });

        // bootbox.confirm({
        //     buttons: buttons,
        //     size: "small",
        //     message: htmlText,
        //     callback: (result) => {
        //         /* result is a boolean; true = OK, false = Cancel*/
        //         JqueryDialogService.isDialogVisible = false;
        //         console.log("Result ", result);
        //         if (methodDelegate != null) {
        //             methodDelegate(result);
        //         }
        //     }
        // })
    }

    confirmDialog(htmlText: string, data, methodDelegate: (returnValue) => void = null) {
        if (JqueryDialogService.isDialogVisible) {
            return;
        }
        if (!htmlText) {
            return this.confirmDialogForUnsavedChanges(methodDelegate);
        }
        JqueryDialogService.isDialogVisible = true;
        htmlText = '<div class="bootbox-widget-header" style="padding-left: 6px;">Confirm</div><div class="bootbox-content">' + htmlText + '</div>';
        let noButtonLevel = 'Stay';
        if (data && data.stayLabel) {
            noButtonLevel = data.stayLabel;
        }

        let yesButtonLevel = 'Leave';
        if (data && data.leaveLabel) {
            yesButtonLevel = data.leaveLabel;
        }

        const buttons = {
            cancel: {
                label: noButtonLevel,
                className: 'CommandButton cancel'
            },
            confirm: {
                label: yesButtonLevel
                // className: 'CommandButton confirm'
            }
        };

        bootbox.confirm({
            buttons: buttons,
            size: 'small',
            message: htmlText,
            callback: (result) => {
                /* result is a boolean; true = OK, false = Cancel*/
                JqueryDialogService.isDialogVisible = false;
                if (methodDelegate != null) {
                    methodDelegate(result);
                }
            }
        });
    }

    showLoader() {
        if (JqueryDialogService.isDialogVisible) {
            return;
        }
        this.isLoaderHiddenByMethod = false;
        JqueryDialogService.isDialogVisible = true;
        const loaderHtml = '<div style="margin-top:30px;text-align:center"><i class="fa fa-spinner fa-spin fa-3x"></i><p style="font-family:inherit;font-size:13px;color:black;">Please Wait.....</p></div>';
        this.loaderBootbox = bootbox.alert({
            size: 'small',
            message: loaderHtml,
            callback: () => {
                JqueryDialogService.isDialogVisible = false;
                if (this.isLoaderHiddenByMethod === false) {

                }
            }
        });
    }

    hideLoader() {
        if (this.loaderBootbox) {
            this.loaderBootbox.modal('hide');
            JqueryDialogService.isDialogVisible = false;
            this.isLoaderHiddenByMethod = true;
        }
    }


    showBusyLoader() {
        $('#WaitCursorDiv').css('display', 'block');
    }

    showBusyLoaderLongPolling() {
        $('#busyLoader').css('display', 'block');
    }

    hideBusyLoader() {
        if (!this.showLoaderForPolling) {
            $('#WaitCursorDiv').css('display', 'none');
            $('#busyLoader').css('display', 'none');
        }
    }

    openValidationMessageJqueryDialog(htmlText: string, methodDelegate: () => void = null) {
        if (JqueryDialogService.isDialogVisible || !htmlText) {
            return;
        }
        JqueryDialogService.isDialogVisible = true;


        let bootstrapModalSize = '';
        if (htmlText.length > 400) {
            bootstrapModalSize = 'large';
        } else if (htmlText.length < 300) {
            bootstrapModalSize = 'small';
        }

        let headerText = '<div class="bootbox-widget-header" style="padding-left: 6px;">Message</div>';
        if (htmlText.length < 40) {
            headerText += '<div class="bootbox-content" style="padding-top: 40px;text-align: center;">' + htmlText + '</div>';
        } else {
            headerText += '<div class="bootbox-content">' + htmlText + '</div>';
        }

        bootbox.alert(headerText);

    }
}
